import { AuthenticatedUser } from "@services/user/types";
import { hasNoPermission } from "./hasNoPermission";
import { PermissionKey } from "./types";
import { isHomeAccountOnly } from "@common/utils/user";

const pathRegex = /^\/assets\/accounts\/(.*)\/configuration$/;
const permissionKeys: PermissionKey[] = ["accounts", "accountConfiguration"];

export const hasNoPermissionToViewAccountConfig = (
  path: Location["pathname"],
  user: AuthenticatedUser
) => {
  const match = path.match(pathRegex);

  if (!match) return false;

  if (permissionKeys.every((key) => hasNoPermission(user, key))) return true;

  if (isHomeAccountOnly(user)) {
    const pathAccountId = match[1];

    return user.account.id !== pathAccountId;
  }

  return false;
};
